import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { TextInputField } from '../bootstrap/TextInputField';

export function PromoterEditAddressFormStep({
  values,
  districts,
  counties,
  parishes,
  onDistrictChange,
  onCountyChange,
  setFieldValue,
  validateForm,
  errors,
  handleChange,
  savePromoter
}) {
  const intl = useIntl();

  function handleDistrictChange(e) {
    setFieldValue('county', '-1');
    setFieldValue('parish', '-1');
    onDistrictChange(e.target.value);
    setFieldValue('district', e.target.value);
  }

  function handleCountyChange(e) {
    setFieldValue('parish', '-1');
    onCountyChange(e.target.value);
    setFieldValue('county', e.target.value);
  }

  function handleParishChange(e) {
    setFieldValue('parish', e.target.value);
  }

  const handleSubmit = async () => {
    const errors = await validateForm();
    if (Object.keys(errors).length === 0) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      savePromoter(values, setFieldValue);
    }
  };

  return (
    <div>
      
      <Row>
        <label className='mt-4 mb-0'>Indique a sua residência</label>
            <Col md='4'>
              <Form.Group controlId={'district'}>
                <Form.Label>
                  <FormattedMessage id='promoterForm.district' />
                </Form.Label>
                <Form.Control
                  as='select'
                  name={'district'}
                  onChange={(e) => handleDistrictChange(e)}
                  value={values.district}
                  isInvalid={errors.district}>
                  <option value={'-1'}>
                    <FormattedMessage id='all.chooseOne' />
                  </option>
                  {districts.map((district) => (
                    <option key={district.code} value={district.code}>
                      {district.description}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>{errors.district}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md='4'>
              <Form.Group controlId={'county'}>
                <Form.Label>
                  <FormattedMessage id='promoterForm.county' />
                </Form.Label>
                <Form.Control
                  as='select'
                  name={'county'}
                  onChange={(e) => handleCountyChange(e)}
                  value={values.county}
                  isInvalid={errors.county}
                  disabled={values.district === '-1'}>
                  <option value={'-1'}>
                    {values.district !== '-1' ? (
                      <FormattedMessage id='all.chooseOne' />
                    ) : (
                      <FormattedMessage id='all.chooseOneDistrict' />
                    )}
                  </option>
                  {counties.map((county) => (
                    <option key={county.code} value={county.code}>
                      {county.description}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>{errors.county}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md='4'>
              <Form.Group controlId={'parish'}>
                <Form.Label>
                  <FormattedMessage id='promoterForm.parish' />
                </Form.Label>
                <Form.Control
                  as='select'
                  name={'parish'}
                  onChange={(e) => handleParishChange(e)}
                  value={values.parish}
                  isInvalid={errors.parish}
                  disabled={values.county === '-1'}>
                  <option value={'-1'}>
                    {values.county !== '-1' ? (
                      <FormattedMessage id='all.chooseOne' />
                    ) : (
                      <FormattedMessage id='all.chooseOneCounty' />
                    )}
                  </option>
                  {parishes.map((parish) => (
                    <option key={parish.code} value={parish.code}>
                      {parish.description}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>{errors.parish}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md='4'>
              <TextInputField
                controlId={'postalCode'}
                labelId={'promoterForm.postalCode'}
                name={'postalCode'}
                handleChange={handleChange}
                value={values.postalCode}
                isInvalid={errors.postalCode}
                errorMessage={errors.postalCode}
                placeholder={intl.formatMessage({ id: 'all.postalCode.placeholder' })}
              />
            </Col>
        <Col md='8'>
            <TextInputField
              controlId={'address'}
              labelId={'promoterForm.address'}
              name={'address'}
              handleChange={handleChange}
              value={values.address}
              isInvalid={errors.address}
              errorMessage={errors.address}
            />
          </Col>
      </Row>
      <div className='form-actions justify-content-end'>
        <button className='btn btn-primary' type='button' onClick={(e) => handleSubmit(e)}>
          <FormattedMessage id='all.submitButtonText' />
        </button>
      </div>
    </div>
  );
}
